import axiosInstance from "../axiosInstance";

export const fetchKeyMetrics = async (
  tenantId: string,
  startDate?: string,
  endDate?: string
) => {
  try {
    const params: Record<string, string> = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;

    const response = await axiosInstance.get(
      `api/analytics/tenants/${tenantId}/analytics/key-metrics`,
      { params: Object.keys(params).length ? params : undefined }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching key metrics:", error);
    throw error;
  }
};
